import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Hero banner for Oakton Cannabis, showcasing local cannabis policy and culture" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Oakton Cannabis News</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policy changes, and cultural insights in our community. 
          Explore educational resources and news articles that empower you with knowledge about cannabis.
        </p>
        <div className="cta-row">
          <a href="/updates" target="_self">
            Latest Updates
          </a>
          <a href="/education" target="_self" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Get timely information on changes to cannabis legislation and regulations affecting our area.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Learn about the current legal status of cannabis in our region and what it means for residents.
          </p>
        </article>
        <article>
          <h2>Cultural Insights</h2>
          <p>
            Discover the cultural aspects of cannabis use and its impact on our community through articles and interviews.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;